










import { Component, Vue, Prop } from 'vue-property-decorator';
import ClassCard from '../components/ClassCard.vue';

@Component({
    components: {
        ClassCard,
    },
})
export default class WowClasses extends Vue {
    get classes() {
        return this.$store.state.classes;
    }
}

